import { svg as icon } from "@/inline-assets/game-unknown-icon.svg";

export const unknownIcon = `data:image/svg+xml;base64,${btoa(icon)}`;
